export default {
    data() {
        return {
            remainHeight: 30, // 默认剩余高度为30时，就加载
            menuOnOff: false,//后台导航开关
            scrollDomFixedon: false, //是否浮动开关
            addedDom: null, //浮动占位div
            timer: null, //函数防抖时间戳,
            debug:(this.isNotProEnv()?1:0)
        }
    },
    computed: {
        isSingePage() { // 是否是单页面
            return ['login', 'register', 'loginByWechat', 'messageShow'].includes(this.$route.name);
        }
    },
    methods: {
        // 函数防抖功能
        debounce(func, wait = 200) {
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(func, wait);
        },
        // 根据程式码获取城市名信息
        getCityName (citycode)  {
            for(var i = 0; i < FcgjCityList.length; i++){
                for(var j = 0; j < FcgjCityList[i].children.length; j++){
                    if(citycode == FcgjCityList[i].children[j].code){
                        return FcgjCityList[i].children[j].name;
                    }
                }
            }
            return '';
        },
        // 获取城市的行政区信息
        getCityDist (city) {
            for(var x in FcgjCityList){
                for(var xx in FcgjCityList[x]['children']){
                    if(FcgjCityList[x]['children'][xx]['code']==city){
                        return FcgjCityList[x]['children'][xx]['children'];
                    }
                }
            }
            return '';
        },
        // 拨打电话
        _tel (phoneNum) {
            location.href = `tel:${phoneNum}`;
        },
        _scrollHandler() {
            // TODO:: 组件按需重写该方法即可
        },
        _scrollLoad() {
            let scrollTop = this._getScrollTop();
            let domHeight = this._getDomHeight();
            let scrollHeight = scrollTop + window.innerHeight + this.remainHeight;
            // 滚动高度 + 可视高度 + 剩余高度 > 文档高度
            return scrollHeight > domHeight;
        },
        _getScrollTop() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (this.iosBug) {
                scrollTop = document.getElementById('app').scrollTop;
            }
            return scrollTop;
        },
        _getDomHeight() {
            let domHeight = document.documentElement.scrollHeight;
            if (this.iosBug) {
                domHeight = document.getElementById('app').scrollHeight;
            }
            return domHeight;
        },
        // 合并数组或对象 
        // raw 是原对象
        // ext 是需要合并的对象
        // override 是否覆盖 raw 原来的key， 默认会覆盖
        extend(raw, ext, override = true) {
            for(let key in ext){
                if(!raw.hasOwnProperty(key) || override){
                    raw[key]=ext[key];
                }
            }
            return raw;
        },
        // 动态加载 js 及 回调
        async loadScript(src, callback = null) {
            await new Promise(resolve => {
                // 如果已经加载了本js，直接调用回调
                if (this._checkIsLoadScript(src)) {
                    return resolve(callback);
                }
                let scriptNode = document.createElement("script");
                scriptNode.setAttribute("type", "text/javascript");
                scriptNode.setAttribute("src", src);
                document.body.appendChild(scriptNode);
                if (scriptNode.readyState) { //IE 判断
                    scriptNode.onreadystatechange = () => {
                        if (scriptNode.readyState == "complete" || scriptNode.readyState == 'loaded') {
                            return resolve(callback);
                        }
                    }
                } else {
                    scriptNode.onload = () => resolve(callback);
                }
            })
        },
        // 检测是否加载了 js 文件
        _checkIsLoadScript(src) {
            const scriptObjs = Array.from(document.getElementsByTagName('script'));
            return scriptObjs.find(ele => ele.src.includes(src));
        },
        // 反转义 html 实体字符
        escape2Html(text) {
            let temp = document.createElement("span"); 
            temp.innerHTML = text; 
            let output = temp.innerText || temp.textContent;
            temp = null; 
            return output; 
        },
        //获取指定长度字符串
        randomString(len) {
            len = len || 32;
            var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
            var maxPos = $chars.length;
            var pwd = '';
            for (let i = 0; i < len; i++) {
                pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
            }
            return pwd;
        },
        // 退出登录
        async logout() {
            await this.axios.get('/api/user/loginOut').then(({status, data}) => {
                console.log(status, data);
                // 退出登录 则 退出用户信息
                const userToken = '';
                // 退出后 userToken 置空
                this.$store.dispatch("updateUser", {userToken});
                // 用户身份信息置空
                this.$store.dispatch("setUserInfo", {});
                // 用户权限置空
                this.$store.dispatch("setUserMenu", []);
            });
        },
        // 下滑设置浮动
        _scrollDomFixed (selector) { // selector: 需要浮动的dom节点
            let thisDom = document.querySelector(selector);
            let scrollTop = this._getScrollTop();
            let offsetTop = thisDom.offsetTop;
            this.scrollDomFixedon = scrollTop > offsetTop;
            if (this.scrollDomFixedon) {
                // 新添加一个占位div
                if (this.addedDom) return false;
                let newDom = document.createElement("div")
                newDom.style.height = thisDom.offsetHeight + 'px';
                thisDom.parentNode.insertBefore(newDom, thisDom);
                this.addedDom = newDom;
            } else {
                // 删除占位div
                thisDom.parentNode.removeChild(this.addedDom);
                this.addedDom = null;
            }
        },
        toast(message = '', onClose = () => {}) {
            this.$toast({
                message,
                className: 'vantCustomToast',
                onClose
            })
        },
        // 是否是开发环境
        isDevENV() {
            return process.env.NODE_ENV == 'development';
        },
        // 是否是测试环境
        isTestENV() {
            return location.href.includes('test');
        },
        // 是否不是生产环境
        isNotProEnv() {
            return this.isDevENV() || this.isTestENV();
        },
        console(msg){
            if(this.debug){
                console.log(msg);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/mixin.js